import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Loadcomps from './loadcomps';
import config from '../config';

class App extends Component {
  render() {
    const { location } = this.props;
    return (
      <Switch key={location.pathname} location={location}>
        {config.pages.map(page => <Route exact path={page.hash} key={page.title} component={Loadcomps(() => import(`../${page.path}`))} />)}
        {/* 404 */}
        <Route component={Loadcomps(() => import('../pages/404/index'))} />
      </Switch>
    )
  }
}
export default withRouter(App);